/**
 * BP Theme Overrides
 * Client-specific design tokens for BP energy company
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/default/default.png';

export const bpThemeOverrides: ClientThemeOverrides = {
  clientId: 'bp',
  logo,
  clientName: 'BP',
  palette: {
    light: {
      primary: {
        main: '#109a2e',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#505050',
        contrastText: '#ffffff',
      },
      info: {
        main: '#ffee58',
      },
      error: {
        main: '#CD5C5C',
      },
      warning: {
        main: '#DAA520',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#109a2e',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
    dark: {
      primary: {
        main: '#3bb375',
        contrastText: '#000000',
      },
      secondary: {
        main: '#808080',
        contrastText: '#ffffff',
      },
      background: {
        default: '#121212',
        paper: '#1E1E1E',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.87)',
        secondary: 'rgba(255, 255, 255, 0.6)',
      },
      info: {
        main: '#ffee58',
      },
      error: {
        main: '#ef5350',
      },
      warning: {
        main: '#ffa726',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#0d7a25',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
  },
  typography: {
    h1: {
      fontSize: '1.3rem',
      fontWeight: 500,
      marginLeft: 0,
    },
    h2: {
      fontSize: '1.2rem',
      fontWeight: 400,
    },
    h5: {
      fontSize: '1.2rem',
      fontWeight: 400,
    },
    h6: {
      fontSize: '1.0rem',
      fontWeight: 400,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
            height: '100%',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.flat': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '& .MuiCardActions-root': {
              justifyContent: 'flex-end',
            },
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '1.3rem',
          fontWeight: 500,
          marginLeft: 0,
        },
        h2: {
          fontSize: '1.2rem',
          fontWeight: 400,
        },
        h5: {
          fontSize: '1.2rem',
          fontWeight: 400,
        },
        h6: {
          fontSize: '1.0rem',
          fontWeight: 400,
        },
      },
    },
  },
  dataGrid: {
    highlightedCell: {
      backgroundColor: '#e1001aaf',
      textColor: '#ffffff',
    },
  },
};
